import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import uuidv4 from 'uuid/v4';

import styles from './button.less';

export default function copyButtonFactory(Button, ReactTooltip) {
  class CopyButton extends PureComponent {
    static propTypes = {
      primary: PropTypes.bool,
      place: PropTypes.string,
      children: PropTypes.node,
      className: PropTypes.string,
      buttonClassName: PropTypes.string,
      tooltipClassName: PropTypes.string,
      onClick: PropTypes.func,
      value: PropTypes.string.isRequired,
    };

    static defaultProps = {
      primary: true,
      className: '',
      place: 'bottom',
      buttonClassName: '',
      onClick: () => {},
      tooltipClassName: '',
    };

    state = {
      tooltipId: uuidv4(),
    };

    copyToClipboard = () => {
      const el = document.createElement('textarea'); // Create a <textarea> element
      el.value = this.props.value; // Set its value to the string that you want copied
      el.setAttribute('readonly', ''); // Make it readonly to be tamper-proof
      el.style.position = 'absolute';
      el.style.left = '-9999px'; // Move outside the screen to make it invisible
      this.copyOuterEl.appendChild(el); // Append the <textarea> element to the HTML document
      const selected =
        document.getSelection().rangeCount > 0 // Check if there is any content selected previously
          ? document.getSelection().getRangeAt(0) // Store selection if found
          : false; // Mark as false to know no selection existed before
      el.select(); // Select the value
      document.execCommand('copy'); // Copy - only works when reacting to a user action (e.g. click events)
      this.copyOuterEl.removeChild(el); // Remove the <textarea> element
      if (selected) {
        // If a selection existed before copying
        document.getSelection().removeAllRanges(); // Unselect everything on the HTML document
        document.getSelection().addRange(selected); // Restore the original selection
      }
      this.props.onClick();
    };

    render() {
      const { tooltipId } = this.copyToClipboard;
      const {
        className,
        buttonClassName,
        tooltipClassName,
        primary,
        place,
        children,
        ...buttonProps
      } = this.props;

      return (
        <div
          className={classnames(styles['copy-outer'], className)}
          ref={el => {
            this.copyOuterEl = el;
          }}
        >
          <Button
            {...buttonProps}
            className={classnames(styles['button--copy'], buttonClassName)}
            primary={primary}
            icon="copy"
            onClick={this.copyToClipboard}
            data-tip="Copied to clipboard"
            data-for={tooltipId}
          >
            {children}
          </Button>

          <ReactTooltip
            className={classnames(styles['copied-tooltip'], tooltipClassName)}
            id={tooltipId}
            place={place}
            event="click"
            eventOff="click"
            delayHide={1000}
            isCapture
          />
        </div>
      );
    }
  }

  return CopyButton;
}
